import type { NumberSpeller } from './types'

const ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
  'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen']
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']

function below100(n: number): string {
  if (n < 20) return ONES[n]
  return TENS[Math.floor(n / 10)] + (n % 10 ? `-${ONES[n % 10]}` : '')
}

function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  return [h ? `${ONES[h]} hundred` : '', r ? below100(r) : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'crore'], [100_000, 'lakh'], [1000, 'thousand']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const en: NumberSpeller = {
  spell,
  year: (n) => (n >= 2000 && n < 2100 ? spell(n) : `${below100(Math.floor(n / 100))} ${below100(n % 100)}`),
  rupees: 'rupees'
}
